import { render, staticRenderFns } from "./EhliyetForm.vue?vue&type=template&id=508c870e"
import script from "./EhliyetForm.vue?vue&type=script&lang=ts"
export * from "./EhliyetForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports